import React from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import LogoWithBrandName from '../Common/LogoWithBrandName';
import AllRightsReserved from '../AllRightsReserved/AllRightsReserved';
import LanguageSwitcher from '../SignUp/LanguageSwitcher';

interface AuthPagesLayoutProps {
  children: React.ReactNode;
  xs?: number;
  md?: number;
  lg?: number;
}

function OnboardingPagesLayout({ xs, md, lg, children }: AuthPagesLayoutProps) {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="space-between"
      minHeight="100vh"
      pb={1}
      sx={{ background: 'linear-gradient(163deg, #FFF 10.13%, #FFF4F0 89.18%)' }}
    >
      <Grid
        container
        alignItems="center"
        justifyContent="space-between"
        pt={4}
        px={{ xs: 2, md: 5, lg: 17.5 }}
      >
        <LogoWithBrandName paddingTop={0} />
        <LanguageSwitcher />
      </Grid>

      <Grid
        container
        item
        xs={xs}
        md={md}
        lg={lg}
        pb={2}
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
      >
        {children}
      </Grid>
      <AllRightsReserved />
    </Box>
  );
}

export default OnboardingPagesLayout;
